import { Component, Input, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { KeepActions } from 'src/app/common/store/actions/keep.actions';
import { BehaviorSubject, Observable } from 'rxjs';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { JobDialogComponent } from '../job-dialog/job-dialog.component';
import { selectAllJobs, selectLoggedInUserDataId } from 'src/app/common/store/state/app.state';
import { JobItemDialogComponent } from '../job-item-dialog/job-item-dialog.component';
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { SelectDialogComponent } from 'src/app/public/common/components/select-dialog/select-dialog.component';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';
import { ObjectSource, GeneralBasicData } from 'src/app/public/common/constants/general-basic-data';
import { Country } from 'src/app/public/common/models/country.model';
import { ObjectData } from 'src/app/public/common/models/object-data.model';
import { JobStatus, JobAction, KeepBasicData } from '../../constants/keep-basic-data';
import { Job } from '../../models/job.model';


@Component({
    selector: 'app-jobs',
    templateUrl: './jobs.component.html',
    styleUrls: ['./jobs.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatFormFieldModule, MatDialogModule, MatIconModule, MatDatepickerModule, MatSelectModule]
})
export class JobsComponent implements OnInit{

  // @Input() jobs: Job [] = [];
  // @Input() fetchingResults: boolean = false;
  // @Input() newJobCarId: string = '';
  // @Input() newJobCount: number = 0;

  @Input() potentialProviders: string [] = [];

  @Input() objectSource: ObjectSource = ObjectSource.DEALER;
  @Input() offerId: string = "";
  @Input() carId: string = "";
  @Input() enableNew: boolean = false;

  jobs$: Observable<Job[]>;
  jobs: Job[] = [];

  selectedProviderId = "";

  currentUserId$ : Observable<string>;
  currentUserId: string = "";

  ObjectSource = ObjectSource;

  JobStatus = JobStatus;
  JobAction = JobAction;

  jobActionItems = KeepBasicData.jobActionItems

  constructor(
    private router: Router,
    private store: Store, 
    private readonly sanitizer: DomSanitizer,
    public dialog: MatDialog) {

      this.jobs$ = this.store.select(selectAllJobs(this.objectSource, this.offerId, this.carId))     
      this.currentUserId$ = store.select(selectLoggedInUserDataId);
    }

  ngOnInit(): void {
    this.currentUserId$.subscribe(
        (id: string) => this.currentUserId = id
    );
      // console.log("hrtt "+this.objectSource)
    this.jobs$ = this.store.select(selectAllJobs(this.objectSource, this.offerId, this.carId))
    
    this.jobs$.subscribe(
      (jbs: Job[]) => this.jobs = jbs
    );
    
  }

  updateProvider(actvt: Job, providerId: string){

    let job: Job = JSON.parse(JSON.stringify(actvt));

    job.providerId = providerId;
    this.store.dispatch(KeepActions.jobActionSubmit ( { jobAction: JobAction.EDIT, job: job, objectSource: this.objectSource }));

  }

  openProviderDialog(carId: string): void {
    
    const dialogRef = this.dialog.open(SelectDialogComponent, {
      data: {options: this.potentialProviders, label: "Nouveau provider"}
    });

    dialogRef.afterClosed().subscribe((result: string) => {
      console.log('New provider = '+result+ " car Id = "+carId);
      //let newPrice: Price = new Price(businessLine, result, 0);
      
      if(result != undefined){
        this.store.dispatch(DealerActions.updateCarProviderSubmit( {carId: carId, providerId: result }));
      }
        
    });
  }
  //updateProvider(job, selectedProviderId)


  openJobDialogOld(carId: string, prop?: Job): void {

    //console.log('index = '+JSON.parse(JSON.stringify(prop!)));
    let job: Job;

    if(prop !== undefined){
      job = JSON.parse(JSON.stringify(prop!));
      console.log('hello 1')
    }else{
      job = new Job();
      job.carId = carId;
      console.log('hello 2')
    }

    let isReschedule: boolean = (job.scheduledDate === '1'); // 1 is to indicate that reschedule has to be edited

    //console.log('prop = '+JSON.stringify(carId));
    const dialogRef = this.dialog.open(JobDialogComponent, {
      data: job
    });
    
    dialogRef.afterClosed().subscribe((result: Job) => {

      console.log('helloo = '+JSON.stringify(result));
      
      if(result != undefined ){

        //console.log('New job = '+result.status+ " date = "+result.jobDate+ " car Id = "+JSON.stringify(result));
        if(result.jobId === ''){
          console.log('new');
          this.store.dispatch(KeepActions.jobNewSubmit ( { job: result, objectSource: this.objectSource }));
          return;
        }

        if(isReschedule){
          console.log('reschedule')
          this.store.dispatch(KeepActions.jobRescheduleSubmit ( { jobId: result.jobId, schedDate: result.scheduledDate, objectSource: this.objectSource }));
          return;
        }

        else{
          console.log('update')
          this.store.dispatch(KeepActions.jobActionSubmit ( { jobAction: JobAction.EDIT, job: result, objectSource: this.objectSource }));          
          return;
        } 
      }  
    });
  }

  openJobDialog(carId: string, offerId: string, jobId: string, jobAction?: JobAction): void {
    
    let objectData: ObjectData = new ObjectData(this.objectSource, offerId, +jobId, CarBusinessLine.KEEP, carId)

    objectData.objectAction = jobAction;
  
    const dialogRef = this.dialog.open(JobDialogComponent, {

      data: objectData

    });
  }

  openJobItemDialog(carId: string, offerId: string, jobId: string, jobItemId: number){

    let objectData: ObjectData = new ObjectData(this.objectSource, offerId, +jobId, CarBusinessLine.KEEP, carId)

    objectData.itemId = jobItemId
  
    const dialogRef = this.dialog.open(JobItemDialogComponent, {

      data: objectData

    });
  }

  updateJobStatus(jobId: string, status: JobStatus){

    //console.log('heyy   '+status.toString());

    this.store.dispatch(KeepActions.jobStatusUpdateSubmit ( { jobId: jobId, status: status, objectSource: this.objectSource }));

  }

  rescheduleJob(job: Job){

    let prop: Job = JSON.parse(JSON.stringify(job));
    
    prop.scheduledDate = '1'; // 1 is to indicate that reschedule has to be edited

    //this.openJobDialog("", prop);

    this.openJobDialog(job.carId, job.offerId, job.jobId);
  }

  deleteJobItem(jobItemId: number){

    console.log(jobItemId)

      this.store.dispatch(KeepActions.jobItemDeleteSubmit ( { jobItemId: jobItemId, objectSource: this.objectSource }));

  }

  executeAction(job: Job, action: JobAction){

    if(action === JobAction.EDIT){
      this.openJobDialog(job.carId, job.offerId, job.jobId)
    }
    else{
      this.store.dispatch(KeepActions.jobActionSubmit ( { jobAction: action, job: job, objectSource: this.objectSource }));  
    }
  }

  moneyFormat(s: string): string{
    return AppFunctions.numberWithSpaces(s);
  }

  dateFormat(dt: string): string{

    return AppFunctions.stringToDatetime(dt);
  }

  getCountryByCode(code: string): Country{
    return GeneralBasicData.getCountryByCode(code)!;
  }

  getJobCategoryTitle(code: string): string{
      return KeepBasicData.getCarJobCategoryTitle(code)!;
  }

}
